import { Box, BoxProps } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useStore } from "../store/StoreProvider";
import { Countdown } from "./Countdown";
import { ShimmerEffect } from "./ShimmerEffect";
import { useNavigate } from "react-router-dom";

interface BannerProps {
  height: BoxProps["height"];
}

export const Banner = ({ height }: BannerProps) => {
  const [now, setNow] = useState(Date.now());
  const { state } = useStore();
  const activityList = state.activityList;
  const navigate = useNavigate();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const currentActivity = useMemo(
    () => activityList.find((a) => now >= a.startTime && now <= a.endTime),
    [activityList, now]
  );

  const firstActivity = useMemo(
    () =>
      activityList.length === 0
        ? undefined
        : activityList.reduce((prev, curr) =>
            !prev ? curr : prev.startTime < curr.startTime ? prev : curr
          ),
    [activityList]
  );

  return (
    <Box height={height} minH={height} width={"100%"}>
      {currentActivity ? (
        <Box
          color={currentActivity.textColor}
          height={"100%"}
          width={"100%"}
          display={"flex"}
          backgroundColor={currentActivity.textColor}
          onClick={() => {
            navigate(`/activity/${currentActivity.id}`);
          }}
        >
          <Box
            width={"100%"}
            padding={1}
            paddingLeft={4}
            paddingRight={4}
            position={"relative"}
            backgroundColor={currentActivity.background}
          >
            <Box
              fontWeight={"bold"}
              fontSize={"large"}
              maxW={"190px"}
              overflow={"hidden"}
              whiteSpace={"nowrap"}
              textOverflow={"ellipsis"}
            >
              {currentActivity.title}
            </Box>
            <Box
              opacity={"0.8"}
              maxW={"190px"}
              overflow={"hidden"}
              whiteSpace={"nowrap"}
              textOverflow={"ellipsis"}
            >
              {currentActivity.description}
            </Box>
          </Box>
          <Box
            width="0px"
            height="0px"
            borderStyle="solid"
            borderWidth={`${height} 26px 0 0`}
            position={"relative"}
            left={"-1px"}
            borderColor={`${currentActivity.background} transparent transparent transparent`}
            transform="rotate(0deg)"
          />
          <Box
            width={"90%"}
            color={currentActivity.background}
            padding={1}
            paddingLeft={4}
            paddingRight={4}
            display={"flex"}
            flexDir={"column"}
            alignItems={"center"}
          >
            <Box marginBottom={1} fontWeight={"bold"} filter={"grayscale(0.5)"}>
              Ends In:
            </Box>
            <Countdown
              timeLeftMs={Math.max(0, currentActivity.endTime - now)}
            />
          </Box>
        </Box>
      ) : firstActivity && now <= firstActivity.startTime ? (
        <Box
          width={"100%"}
          padding={1}
          paddingLeft={4}
          paddingRight={4}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          height={"100%"}
          position={"relative"}
          background={
            "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)"
          }
        >
          <ShimmerEffect />
          <Box
            marginBottom={1}
            fontWeight={"bold"}
            color={"#ffffff"}
            fontSize={"x-large"}
            marginRight={4}
          >
            Camp Starts in:
          </Box>
          <Countdown
            color={"#ffffff"}
            timeLeftMs={Math.max(0, firstActivity.startTime - now)}
          />
        </Box>
      ) : null}
    </Box>
  );
};
